import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { LoginUserOnlineService } from "./_services/http-api/login-user-online.service";

@NgModule({
  imports: [CommonModule],
  exports: [],
  declarations: [],
  providers: [
    // singleton services
    LoginUserOnlineService
  ]
})
export class CoreModule {}
